(function ($) {
    var icounter = 0;

    function top(e) {
        return e.offset().top;
    }

    function bottom(e) {
        return e.offset().top + e.height();
    }

    function onscroll(element, scrollbar, scrollLeft) {
        scrollbar.show();
        if (top(element) < top(scrollbar) && bottom(element) > bottom(scrollbar)) {
            scrollbar.find('div').css('width', element.get(0).scrollWidth + 'px');
            scrollbar.css({left: element.offset().left, width: element.outerWidth()});
            scrollbar.scrollLeft(scrollLeft);
        } else {
            scrollbar.hide();
        }
    }

    function init(container) {
        container.find('.sticky-hscroll').each(function () {
            var element = $(this);
            if (element.data('has-sticky-hscroll') === true && !container.data('do-no-return-at-first')) {
                return;
            }
            var id = icounter++;

            element.data('has-sticky-hscroll', true);
            container.data('do-no-return-at-first', false);
            var scrollbar = $('<div class="sticky-hscroll-scrollbar"><div></div></div>');
            var scrollLeft = 0;
            scrollbar.appendTo($(document.body));
            scrollbar.hide();
            scrollbar.css({
                overflowX: 'auto',
                position: 'fixed',
                width: '100%',
                bottom: 0,
                zIndex: 1050
            });
            scrollbar.find('div').css('height', '1px');
            onscroll(element, scrollbar, scrollLeft);

            scrollbar.bind('scroll.sticky-hscroll-' + id, function () {
                element.scrollLeft(scrollbar.scrollLeft());
            });
            element.bind('scroll.sticky-hscroll-' + id, function () {
                scrollLeft = element.scrollLeft();
            });
            container.bind('scroll.sticky-hscroll-' + id, function () {
                onscroll(element, scrollbar, scrollLeft);
            });
            $(document).bind('scroll.sticky-hscroll-' + id, function () {
                onscroll(element, scrollbar, scrollLeft);
            });
            $(window).bind('resize.sticky-hscroll-' + id, function () {
                onscroll(element, scrollbar, scrollLeft);
            });

            const observer = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    mutation.removedNodes.forEach((node) => {
                        if (node === element[0]) { // Check if the removed node is the element itself
                            // Your existing logic
                            $(document).unbind('.sticky-hscroll-' + id);
                            $(window).unbind('.sticky-hscroll-' + id);
                            container.unbind('.sticky-hscroll-' + id);
                            scrollbar.unbind('.sticky-hscroll-' + id);
                            element.unbind('.sticky-hscroll-' + id);
                            scrollbar.remove();

                            // Stop observing once the element has been removed
                            observer.disconnect();
                        }
                    });
                }
            });

            // Start observing the parent node for childList changes
            if (element[0].parentNode) {
                observer.observe(element[0].parentNode, {
                    childList: true,
                    subtree: false // Only observe direct children of the parent node
                });
            }
        });
    }

    $.fn.stickyHScroll = function () {
        var container = this;
        init(container);

        container.scroll(function () {
            init(container);
        });

        $(document).scroll(function () {
            init(container);
        });

        $(window).resize(function () {
            init(container);
        });

        return this;
    };
}(jQuery));
